// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"iosPlayer_videoContainer__vgI4x"};